'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _domready = require('domready');

var _domready2 = _interopRequireDefault(_domready);

var _manager = require('./manager');

var _manager2 = _interopRequireDefault(_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var origPopups = window && window.popups;
var popups = origPopups || new _manager2.default();

if (!origPopups) {
  (0, _domready2.default)(function () {
    return popups.init();
  });
  if (window) {
    window.popups = popups;
  }
}

exports.default = popups;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-popups@4.2.3@@ali/ve-popups/build/index.js
// module id = 282
// module chunks = 0